const asyncActionType = type => ({
  pending: `${type}/PENDING`,
  success: `${type}/SUCCESS`,
  error: `${type}/ERROR`
});

const GET_GROSS_RECIEPTS = asyncActionType('aerosimple/documents/GET_GROSS_RECIEPTS');
const CREATE_GROSS_RECIEPTS = asyncActionType('aerosimple/documents/CREATE_GROSS_RECIEPTS');
const GET_CONTRACTS = asyncActionType('aerosimple/documents/GET_CONTRACTS');
const GET_GROSS_RECIEPT_DETAIL = asyncActionType('aerosimple/documents/GET_GROSS_RECIEPT_DETAIL');
const GROSS_RECIEPTS_CLEAR_ACTION = 'GROSS_RECIEPTS_CLEAR_ACTION';

export {
  GET_GROSS_RECIEPTS,
  CREATE_GROSS_RECIEPTS,
  GET_CONTRACTS,
  GET_GROSS_RECIEPT_DETAIL,
  GROSS_RECIEPTS_CLEAR_ACTION
};
